import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import useWPCloudStripeConfigurationQuery from 'data/wpcloud/use-wpcloud-stripe-configuration-query';

export const StripeElementsContext = createContext<ReturnType<typeof loadStripe> | null>( null );

export default function StripeProvider( { children }: PropsWithChildren ) {
	const { data: stripeConfiguration } = useWPCloudStripeConfigurationQuery();
	const [ stripePromise, setStripePromise ] = useState<ReturnType<typeof loadStripe> | null>( null );

	useEffect( () => {
		if ( stripeConfiguration ) {
			setStripePromise( loadStripe( stripeConfiguration.public_key ) );
		}
	}, [ stripeConfiguration ] );

	return (
		<StripeElementsContext.Provider value={ stripePromise }>
			{ stripePromise && (
				<Elements stripe={ stripePromise }>
					{ children }
				</Elements>
			) }

			{ ! stripePromise && children }
		</StripeElementsContext.Provider>
	);
}
